module.exports = __webpack_public_path__ + "img/login_font.721ec8dd.png";